import WidgetModel from '../widget-model'
import InitiativeChartView from './initiative-chart-view'
import _ from 'lodash'

var InitiativeChartModel = WidgetModel.extend({
	containerDefaults: {
		width: 480,
		height: 330
	},

	viewCls: InitiativeChartView,

	section: _.constant('initiatives'),

	multiSettableProps: [ 'background', 'showLabel' ]
})

export default InitiativeChartModel

InitiativeChartModel.__filename__ = 'dashboards/widgets/initiative-chart/initiative-chart-model.js'
